import Button from '@/components/Button/Button';
import React from 'react';
import { sendAnalytics } from '@/services/analyticsService';
import { shallowEqual, useSelector } from 'react-redux';
import type { RootState } from '@/rootReducer';
import { useSequencesContext } from '../../SequencesContext';

export default function SequencesContainerHeader() {
	const [user] = useSelector(
		(state: RootState) => [state.user.getIn(['authorize', 'user']).toJS()],
		shallowEqual
	);

	const {
		setSequencePage,
		setSelectedSequence,
		setSelectedTemplate,
		templates
	} = useSequencesContext();

	function handleNewSequence() {
		setSelectedSequence({
			name: 'New sequence',
			steps: [],
			status: 'DRAFT'
		});
		if (templates) {
			setSelectedTemplate(templates[0]);
		}
		setSequencePage('SEQUENCE-START');

		sendAnalytics({
			type: 'track',
			userId: user.email,
			eventName: 'user_clicked_new_sequence'
		});
	}

	return (
		<div className="w-full rounded-lg bg-dm-black px-4 pb-3 pt-2">
			<div className="flex items-center justify-between">
				<div className="w-34 h-10">
					<Button
						rightIcon={<PlusSignIcon />}
						onClick={handleNewSequence}
					>
						New sequence
					</Button>
				</div>
				<div className="h-10 w-3/5">
					<InputWithIcon />
				</div>
			</div>
		</div>
	);
}

function InputWithIcon() {
	const { setSequenceSearch, sequenceSearch } = useSequencesContext();

	function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		setSequenceSearch(e.target.value);
	}

	return (
		<div className="relative h-full w-full">
			<input
				type="text"
				placeholder="Search a Sequence"
				className="h-full w-full"
				value={sequenceSearch}
				onChange={handleChange}
			/>
			<button
				type="submit"
				className="absolute bottom-0 right-2 top-0 flex items-center text-orange"
			>
				<SearchIconNew />
			</button>
		</div>
	);
}

export function SearchIconNew() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-6 w-6"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
			/>
		</svg>
	);
}
function PlusSignIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="h-5 w-5"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 4.5v15m7.5-7.5h-15"
			/>
		</svg>
	);
}
